class ElanneSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === "true") return;
    this.dataset.ready = "true";
    this.track = this.querySelector("[data-slider-track]");
    this.previous = this.querySelector("[data-slider-prev]");
    this.next = this.querySelector("[data-slider-next]");
    if (!this.track) return;
    this.movePrevious = () => this.move(-1);
    this.moveNext = () => this.move(1);
    this.update = () => {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= max - 2;
      if (this.previous) {
        this.previous.disabled = atStart;
        this.previous.setAttribute("aria-disabled", String(atStart));
      }
      if (this.next) {
        this.next.disabled = atEnd;
        this.next.setAttribute("aria-disabled", String(atEnd));
      }
    };
    this.previous?.addEventListener("click", this.movePrevious);
    this.next?.addEventListener("click", this.moveNext);
    this.track.addEventListener("scroll", this.update, { passive: true });
    window.addEventListener("resize", this.update);
    requestAnimationFrame(this.update);
  }

  disconnectedCallback() {
    this.previous?.removeEventListener("click", this.movePrevious);
    this.next?.removeEventListener("click", this.moveNext);
    this.track?.removeEventListener("scroll", this.update);
    window.removeEventListener("resize", this.update);
    delete this.dataset.ready;
  }

  move(direction) {
    if (!this.track) return;
    this.track.scrollBy({ left: this.track.clientWidth * 0.82 * direction, behavior: "smooth" });
  }
}

if (!customElements.get("elanne-slider")) customElements.define("elanne-slider", ElanneSlider);

class VariantSelects extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === "true") return;
    this.dataset.ready = "true";
    this.select = this.querySelector("select");
    this.product = this.closest("[data-product]");
    this.update = () => {
      const option = this.select?.selectedOptions?.[0];
      if (!option || !this.product) return;
      const available = option.dataset.available !== "false";
      this.product.querySelectorAll("[data-price],[data-mobile-price]").forEach((price) => {
        if (option.dataset.price) price.textContent = option.dataset.price;
      });
      const stock = this.product.querySelector("[data-stock-status]");
      if (stock) stock.textContent = available ? this.product.dataset.inStockLabel : this.product.dataset.soldOutLabel;
      const desktop = this.product.querySelector("[data-product-submit]");
      const mobile = this.product.querySelector("[data-product-mobile-submit]");
      if (desktop) {
        desktop.disabled = !available;
        desktop.textContent = available ? this.product.dataset.addLabel : this.product.dataset.soldOutLabel;
      }
      if (mobile) {
        mobile.disabled = !available;
        mobile.textContent = available ? this.product.dataset.mobileAddLabel : this.product.dataset.soldOutLabel;
      }
      this.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { option, available } }));
    };
    this.select?.addEventListener("change", this.update);
    this.update();
  }

  disconnectedCallback() {
    this.select?.removeEventListener("change", this.update);
    delete this.dataset.ready;
  }
}

if (!customElements.get("variant-selects")) customElements.define("variant-selects", VariantSelects);

document.documentElement.classList.remove("no-js");